import { type ProductCounters, type Transport } from '@/domainLogic/index.ts';
import { SortValues } from '@/app/common/memsearch/types.ts';

export const SEARCH_SERVED = 'SEARCH_SERVED';
export const SEARCH_SERVED_VERSION = '2.1';
export const SEARCH_SERVED_BE = 'SEARCH_SERVED_BE';
export const SEARCH_SERVED_BE_VERSION = '1.1';

export type SearchServedParams = {
  searchId: string;
  responseDetail: string;
  productCounters: ProductCounters | null;
  numberOfDealCards: number;
  defaultSortOrder: string;
  vcSearchId?: string;
  transport?: Transport;
  voucherCode?: string;
  instantSearch: boolean;
  apexAvailabilityFlag: boolean;
};

export type SearchServedPayload = {
  searchId: string;
  responseCode: string;
  responseDetail: string;
  numberOfResults: number;
  totalAlternativePackagesQty: number;
  totalAlternativeAccommodationsQty: number;
  absoluteCheapestPrice: number;
  firstPriceBySorting: number;
  cheapestPriceFirstPage: number;
  defaultSortOrder: string;
  vcSearchId: string;
  packageDiscountAvailable: number;
  packageDiscountEnabled: number;
  voucherCode: string;
  // numberOfMembershipResults?: number;
  // totalNumberOfAlternativeFlights: number;
  // totalNumberOfAlternativeFlightsRyanair: number;
  cached_flag: number;
  ApexAvailabilityFlag: boolean;
};

export const createSearchServedPayload = (params: SearchServedParams): SearchServedPayload => {
  const {
    searchId,
    responseDetail,
    productCounters,
    numberOfDealCards,
    defaultSortOrder,
    vcSearchId,
    // transport,
    voucherCode,
    instantSearch,
    apexAvailabilityFlag,
  } = params;
  const numberOfResults = productCounters?.productsCount ?? 0;

  const payload: SearchServedPayload = {
    searchId: searchId || '',
    responseCode: numberOfResults === 0 ? 'KO' : 'OK',
    responseDetail: responseDetail || '',
    numberOfResults,
    totalAlternativePackagesQty: productCounters?.productsCountTo ?? 0,
    totalAlternativeAccommodationsQty: productCounters?.productsCountAlternative ?? 0,
    absoluteCheapestPrice: numberOfDealCards > 0 ? (productCounters?.productsPriceStats.absoluteCheapestPrice ?? 0) : 0,
    firstPriceBySorting: numberOfDealCards > 0 ? (productCounters?.productsPriceStats?.firstPriceBySorting ?? 0) : 0,
    cheapestPriceFirstPage:
      numberOfDealCards > 0 ? (productCounters?.productsPriceStats?.cheapestPriceFirstPage ?? 0) : 0,
    defaultSortOrder: defaultSortOrder || SortValues.Recommended,
    vcSearchId: vcSearchId || '',
    packageDiscountAvailable: productCounters?.productsPackageDiscountAvailable ?? 0,
    packageDiscountEnabled: productCounters?.productsPackageDiscountEnabled ?? 0,
    voucherCode: voucherCode || '',
    // numberOfMembershipResults: productCounters?.productsCountPlus || 0,
    // totalNumberOfAlternativeFlights: transport?.counters?.flightsCounter || 0,
    // totalNumberOfAlternativeFlightsRyanair: transport?.counters?.flightsCounterFr || 0,
    cached_flag: instantSearch ? 1 : 0,
    ApexAvailabilityFlag: !!apexAvailabilityFlag, // Needs to force boolean as could be undefined
  };

  return payload;
};
